"use client";

import { redirect } from "next/navigation";
import { useEffect } from "react";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const { lang } = useLang();
  useEffect(() => {
    console.error("error:", error);
    redirect(`/${lang}/${links.myBlog}`);
  }, [error]);
  return null;
}
